export default "__VITE_PUBLIC_ASSET__f78bb758__"